const getPropertyDefinition = (properties, propertyName) => {
  return properties[propertyName].definition;
};
export default getPropertyDefinition;